import { render, staticRenderFns } from "./CompareKitsItem.vue?vue&type=template&id=54dccb3c&scoped=true&"
import script from "./CompareKitsItem.vue?vue&type=script&lang=js&"
export * from "./CompareKitsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dccb3c",
  null
  
)

export default component.exports